import React from "react";

import { noiAdjustmentOptions } from "../FilterSection/constants";
import "./styles.css";

const NOIAdjuster = ({ selectedNoiAdjustment, onChange }) => (
  <div className="noi-adjuster-wrapper">
    {
      noiAdjustmentOptions.map(({ label, value }) => <div
        key={value}
        className={`noi-adjuster-item ${label === "NOI +0%" ? "separator-border" : ""} ${selectedNoiAdjustment === value ? "noi-selected" : ""}`}
        onClick={() => onChange(value)}
      >
        {label}
      </div>)
    }
  </div>
);

export default NOIAdjuster;
